(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(document).ready(function () {
            var isSessionStorageSupported = window.utils.isSessionStorageSupported;
            function saveCommentItem(comment) {
                if (isSessionStorageSupported) {
                    sessionStorage.setItem('comment', JSON.stringify(comment));
                }
            }
            /**
             * @return {null|{}}
             */
            function getCommentItem() {
                if (isSessionStorageSupported) {
                    var _comment = sessionStorage.getItem('comment');
                    return _comment ? JSON.parse(_comment) : null;
                }
                return null;
            }

            function removeCommentItem() {
                if (isSessionStorageSupported) {
                    sessionStorage.removeItem('comment');
                }
            }

            var $entityField = $('#comment-entityid');
            var $commentRatingField = $('#comment-rating');
            $('.comment-wrapper')
            /**
             * так  как форма "ответа на отзыв" и "нового отзыва" физически одна и та же,
             * скрываем возможность поставить оценку при нажатии на "ответить", и показываем снова
             * при нажатии на "отменить ответ"
             */
            .on('click', '.comment-reply', function () {
                $commentRatingField.hide();
            }).on('click', '#cancel-reply', function () {
                $commentRatingField.show();
            });

            /**
             * Если посетитель не авторизован, то кнопка Опубликовать комментарий на самом деле редирект
             * на авторизацию. Запоминаем что ввел клиент, чтобы не потерять отзыв
             */
            $('#comment-redirect').on('click', function () {
                var comment = {
                    entityId: $entityField.val(),
                    content: $('#comment-content').val(),
                    rating: $commentRatingField.val(),
                    parentId: $('#comment-parentid').val()
                };

                saveCommentItem(comment);
            });

            var comment = getCommentItem();
            if (comment) {
                /** восстанавливаем введенный комментарий после авторизации */
                // если всё ок и вернулись на страницу того же заведения
                var currentCommentEntityId = $entityField.val();
                if (currentCommentEntityId === comment.entityId) {
                    $entityField.val(comment.entityId);
                    $('#comment-content').val(comment.content);
                    $commentRatingField.val(comment.rating);
                    $('#comment-parentid').val(comment.parentId);
                    setTimeout(function () {
                        $('#submit-comment').trigger('click');
                    }, 100);
                }

                removeCommentItem();
            }
        });
    }, {}] }, {}, [1]);